import { TemplateModel } from '@/components/ui';

import { amountFormatter, dateFormatter, highConfidenceValidator } from './common';

export const PAYSLIP: TemplateModel = {
  fields: [
    {
      id: 'employee_name',
      type: 'single-value',
      name: 'Employee Name',
      promptHint: 'Employee name.',
      validators: [highConfidenceValidator],
    },
    {
      id: 'pay_period',
      type: 'single-value',
      name: 'Pay Period',
      promptHint: 'The end date of the time period for which wages are calculated on the payslip.',
      formatters: [dateFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'net_pay',
      type: 'single-value',
      name: 'Net Pay',
      promptHint: 'Net pay.',
      formatters: [amountFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'deductions',
      type: 'single-value',
      name: 'Deductions',
      promptHint: 'Deductions.',
      formatters: [amountFormatter],
      validators: [highConfidenceValidator],
    },
    {
      id: 'gross_pay',
      type: 'single-value',
      name: 'Gross Pay',
      promptHint: 'Gross pay.',
      formatters: [amountFormatter],
      validators: [highConfidenceValidator],
    },
  ],
  sampleDocuments: ['https://public.cradl.ai/sample_documents/Payslip.pdf'],
};
